export type CarMake = {
  id: string;
  name_ar: string;
  name_en: string;
  country_group: 'japanese' | 'korean' | 'german' | 'others';
  logo_url: string;
  is_active: boolean;
  sort_order: number;
};

export type CarModel = {
  id: string;
  make_id: string;
  name_ar: string;
  name_en: string;
  is_active: boolean;
  sort_order: number;
};

export type Listing = {
  id: string;
  title: string;
  price: number;
  year: number;
  make_id: string;
  model_id: string;
  description: string;
  image_url: string;
  created_at: string;
};

export type Part = {
  id: string;
  name_ar: string;
  category: string;
  price: number;
  image_url: string;
  brand: string;
  rating: number;
  sku?: string;
};

export const MOCK_CAR_MAKES: CarMake[] = [
  { id: '1', name_ar: 'تويوتا', name_en: 'Toyota', country_group: 'japanese', logo_url: 'https://picsum.photos/seed/toyota/100/100', is_active: true, sort_order: 1 },
  { id: '2', name_ar: 'هيونداي', name_en: 'Hyundai', country_group: 'korean', logo_url: 'https://picsum.photos/seed/hyundai/100/100', is_active: true, sort_order: 2 },
  { id: '3', name_ar: 'مرسيدس بنز', name_en: 'Mercedes-Benz', country_group: 'german', logo_url: 'https://picsum.photos/seed/mercedes/100/100', is_active: true, sort_order: 3 },
  { id: '4', name_ar: 'بي إم دبليو', name_en: 'BMW', country_group: 'german', logo_url: 'https://picsum.photos/seed/bmw/100/100', is_active: true, sort_order: 4 },
  { id: '5', name_ar: 'نيسان', name_en: 'Nissan', country_group: 'japanese', logo_url: 'https://picsum.photos/seed/nissan/100/100', is_active: true, sort_order: 5 },
  { id: '6', name_ar: 'كيا', name_en: 'Kia', country_group: 'korean', logo_url: 'https://picsum.photos/seed/kia/100/100', is_active: true, sort_order: 6 },
];

export const MOCK_CAR_MODELS: CarModel[] = [
  { id: '1', make_id: '1', name_ar: 'كامري', name_en: 'Camry', is_active: true, sort_order: 1 },
  { id: '2', make_id: '1', name_ar: 'كورولا', name_en: 'Corolla', is_active: true, sort_order: 2 },
  { id: '3', make_id: '2', name_ar: 'إلنترا', name_en: 'Elantra', is_active: true, sort_order: 1 },
  { id: '4', make_id: '3', name_ar: 'الفئة S', name_en: 'S-Class', is_active: true, sort_order: 1 },
  { id: '5', make_id: '1', name_ar: 'لاندكروزر', name_en: 'Land Cruiser', is_active: true, sort_order: 3 },
  { id: '6', make_id: '4', name_ar: 'الفئة الخامسة', name_en: '5 Series', is_active: true, sort_order: 1 },
];

export const MOCK_LISTINGS: Listing[] = [
  {
    id: 'l1',
    title: 'تويوتا كامري 2023 بحالة الوكالة',
    price: 95000,
    year: 2023,
    make_id: '1',
    model_id: '1',
    description: 'سيارة نظيفة جداً، استخدام شخصي، صيانة دورية في الوكالة، خالية من الصدمات والرش، تواير جديدة ملكية سنة.',
    image_url: 'https://picsum.photos/seed/camry/600/400',
    created_at: new Date().toISOString(),
  },
  {
    id: 'l2',
    title: 'مرسيدس بنز S-Class 2022',
    price: 450000,
    year: 2022,
    make_id: '3',
    model_id: '4',
    description: 'كاملة المواصفات، فتحة سقف بانوراما، كراسي مساج، رادار، نقطة عمياء، استخدام راقي جداً.',
    image_url: 'https://picsum.photos/seed/sclass/600/400',
    created_at: new Date().toISOString(),
  },
  {
    id: 'l3',
    title: 'تويوتا كورولا 2021 فل كامل',
    price: 65000,
    year: 2021,
    make_id: '1',
    model_id: '2',
    description: 'اقتصادية جداً في الوقود، حالة ممتازة، شاشة، كاميرا خلفية، حساسات.',
    image_url: 'https://picsum.photos/seed/corolla/600/400',
    created_at: new Date().toISOString(),
  },
  {
    id: 'l4',
    title: 'هيونداي إلنترا 2020 ستاندر',
    price: 52000,
    year: 2020,
    make_id: '2',
    model_id: '3',
    description: 'سيارة عملية جداً، مكينة وقير على الشرط، بودي بلد ماعدا حكات بسيطة.',
    image_url: 'https://picsum.photos/seed/elantra/600/400',
    created_at: new Date().toISOString(),
  },
  {
    id: 'l5',
    title: 'بي إم دبليو الفئة الخامسة 2024 أصفار',
    price: 280000,
    year: 2024,
    make_id: '4',
    model_id: '6',
    description: 'جديدة بالكامل، ضمان الوكيل 5 سنوات، مواصفات خاصة، لون أسود ملكي.',
    image_url: 'https://picsum.photos/seed/bmw5/600/400',
    created_at: new Date().toISOString(),
  },
];

export const MOCK_PARTS: Part[] = [
  { id: 'p1', name_ar: 'فحمات فرامل أمامية', category: 'الفرامل', price: 250, image_url: 'https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=600', brand: 'Brembo', rating: 4.8, sku: 'BR-2024-F' },
  { id: 'p2', name_ar: 'فلتر زيت محرك', category: 'المحرك', price: 45, image_url: 'https://images.unsplash.com/photo-1635773054018-20835064619a?q=80&w=600', brand: 'Denso', rating: 4.5, sku: 'OIL-101' },
];

export const PART_CATEGORIES = ['المحرك', 'الفرامل', 'المساعدات', 'كهرباء', 'زيوت'];

export const APP_SETTINGS = {
  country_code: 'SA',
  country_name_ar: 'المملكة العربية السعودية',
  currency_code: 'SAR',
  currency_symbol: 'ر.س',
  currency_position: 'after',
  default_language: 'ar',
};